import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import WrapperVisionMissionValue from "./WrapperVisionMissionValue";

const CenteredPortraitWoWeAre = ({ hostpitalAbout }) => {
  const sitedata = useSelector((store) => store.global.loginData);
  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };

  const contentArray = homeIntroData?.who_we_are_content || [
    {
      title: "Our Philosophy",
      description: [
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Excepturi facere earum quis ipsa vitae qui minima esse ducimus dolorum iste nisi laborum repellat dolores dolore debitis adipisci nemo quia autem pariatur a voluptatem dignissimos maiores accusantium nobis tempora consequatur cumque quas ea doloribus deleniti.",
        "Quibusdam commodi laboriosam error temporibus iste ipsa soluta distinctio maiores ad totam beatae incidunt veritatis enim? Reiciendis voluptate assumenda quidem eos explicabo rerum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
      ],
    },
    {
      title: "Our History",
      description: [
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Excepturi facere earum quis ipsa vitae qui minima esse ducimus dolorum iste nisi laborum repellat dolores dolore debitis adipisci nemo quia autem pariatur a voluptatem dignissimos maiores accusantium nobis tempora consequatur cumque quas ea doloribus deleniti.",
        "Quibusdam commodi laboriosam error temporibus iste ipsa soluta distinctio maiores ad totam beatae incidunt veritatis enim? Reiciendis voluptate assumenda quidem eos explicabo rerum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
      ],
    },
  ];

  return (
    <>
      <div className="container">

        {homeIntroData &&
          (homeIntroData?.video_link || homeIntroData?.short_summary) && (
            <div className="row d-flex align-items-stretch mt-5">
              {/* Left Column */}
              <div className="col-lg-6 bg-1 bg-grey p-5 d-flex flex-column justify-content-center">
                <div className="title-wrap mb-0">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title text-uppercase mb-0">
                      {/* Who <span className="theme-color">We Are</span> */}
                      {homeIntroData?.main_heading}
                    </h2>
                    <span className="section-border-bottom"></span>
                  </div>
                </div>
                <p className="mb-0">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.short_summary,
                    }}
                  ></span>
                </p>
              </div>

              {/* Right Column */}
              <div className="col-lg-6 bg-2 p-0 div-bg-img d-flex justify-content-center align-items-center center-portrait-whoweare">
                {homeIntroData?.video_link ? (
                  <div
                    className="about-vedio-frame w-100"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.video_link.replace(
                        /src=\"([^\"]+)\"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("rel", "0");
                          newUrl.searchParams.set("mute", "1");
                          return `src="${newUrl.toString()}"`;
                        }
                      ),
                    }}
                  />
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundImage: `url(${homeIntroData?.image || "/assets/images/bg/bg-9.jpg"
                        })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                )}
              </div>
            </div>

          )}


        {hostpitalAbout?.about_short_heading && hostpitalAbout?.about_short_description && (
          <div className=" mt-5">
            <div className="title-wrap text-center mb-0">
              <div className="section-title mb-5">
                <h2 className="title text-uppercase mb-0">
                  {hostpitalAbout.about_short_heading}
                  <span className="theme-color"></span>
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
              <div className=" mb-0">
                <p
                  className="mb-0 about-intro-data-descr"
                  dangerouslySetInnerHTML={{
                    __html: hostpitalAbout.about_short_description,
                  }}
                ></p>
              </div>
            </div>
          </div>
        )}

        {/* {sitedata?.manage_home_page?.vision_mission_values?.Status === 1 &&
          <div className="row">
            <div className="col-12">
              <WrapperVisionMissionValue
                principles={homeIntroData?.principles}
                siteType={sitedata?.site_type}
              />
            </div>
          </div>
        } */}
      </div>
    </>
  );
};

export default CenteredPortraitWoWeAre;
